const typographyFormParamEquipService = {
  text: 'Serviços do Equipamento',
  text1: 'Selecione um site',
  inactive: 'Desabilitado',
};

export default typographyFormParamEquipService;
